function convertDate(date) {
  const months = {
    janvier: "january",
    fevrier: "february",
    mars: "march",
    avril: "april",
    mai: "may",
    juin: "june",
    juillet: "july",
    aout: "august",
    septembre: "september",
    octobre: "october",
    novembre: "november",
    decembre: "december",
  }
  date = date + ""
  date = date.split(" ")
  return date[0] + " " + months[date[1]] + " " + date[2]
}
const regExp = /[a-zA-Z]/g
export const getPublishedData = (data) => {
  const date = new Date()
  const finalData = data.filter(({ node }) => {
    if (node.field_affichage_planifie) {
      if (node.field_date_de_depublication) {
        return (
          new Date(node.field_date_de_publication) <= date &&
          new Date(node.field_date_de_depublication) >= date
        )
      }
      return new Date(node.field_date_de_publication) <= date
    }
    return true
  })
  if (finalData.length > 0) {
    if (finalData[0].node.relationships.field_image_event === undefined) {
      return finalData.sort((firstNode, secondNode) => {
        let dateA =
          firstNode.node.field_date_de_publication ?? firstNode.node.created
        let dateB =
          secondNode.node.field_date_de_publication ?? secondNode.node.created
        if (regExp.test(dateA)) {
          dateA = convertDate(dateA)
        }
        if (regExp.test(dateB)) {
          dateB = convertDate(dateB)
        }
        return new Date(dateB) - new Date(dateA)
      })
    }
  }
  return finalData
}
